export default __webpack_public_path__ + "static/media/mp.a25c25f6.svg";